module.exports = __webpack_public_path__ + "img/icono-experiencia-7.e40ba736.svg";